<template>
	<div
		v-loading="loading"
		class="wrapper"
	>
		<router-view />
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { _getLanguages } from '@/services/api/settings'
import generateAxiosToken from '@/services/mixins/generateAxiosToken'

export default {
	name: 'App',
	metaInfo() {
		return {
			titleTemplate: `%s | ${ this.translations && this.translations.meta && this.translations.meta.title ? this.translations.meta.title : '' }`,
			meta: [
				{ charset: 'utf-8' },
				{ name: 'viewport', content: 'initial-scale=1, width=device-width, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no' },
				{ name: 'description', content: 'E-screen is a one-stop solution for managing remote screens and displays. Engage customers, increase sales and boost productivity with just a few clicks!' },
				{ property: 'og:url', content: 'https://app.e-screen.net' },
				{ property: 'og:title', content: 'e-screen / Digital signage software' },
				{ property: 'og:site_name', content: 'e-screen / Digital signage software' },
				{ property: 'og:description', content: 'E-screen is a one-stop solution for managing remote screens and displays. Engage customers, increase sales and boost productivity with just a few clicks!' },
				{ property: 'og:image', content: 'https://app.e-screen.net/images/share.png' }
			],
			link: [
				{ rel: 'apple-touch-icon', sizes: '180x180', href: `/images/favicons/${this.theme}/apple-touch-icon.png` },
				{ rel: 'icon', type: 'image/png', sizes: '32x32', href: `/images/favicons/${this.theme}/favicon-32x32.png` },
				{ rel: 'icon', type: 'image/png', sizes: '16x16', href: `/images/favicons/${this.theme}/favicon-16x16.png` },
				{ rel: 'manifest', href: `/images/favicons/${this.theme}/site.webmanifest` }
			]
		}
	},
	mixins: [
		generateAxiosToken
	],
	data () {
		return {
			loading: true
		}
	},
	computed: {
        ...mapState(['theme'])
	},
	created () {
		this.initialCall()
	},
	methods: {
		async initialCall () {
			let token = null
			while (!token) {
				try {
					token = await this.generateAxiosToken()
				} catch {
					return false
				}
			}
			this.$store.dispatch('setAxiosToken', token).then(() => {
				this.ajaxLoadLanguages()
				this.setTheme()
			})
		},
		ajaxLoadLanguages () {
			_getLanguages()
				.then(response => {
					this.$store.dispatch('setAvailableLanguages', response.filter(item => item.enabled === true)).then(() => {
						this.loading = false
					})
				})
		},
		setTheme () {
			const darkMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
			this.$store.dispatch('setTheme', darkMediaQuery.matches ? 'dark' : 'light')
			darkMediaQuery.addEventListener('change', () => {
				this.$store.dispatch('setTheme', darkMediaQuery.matches ? 'dark' : 'light')
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.wrapper {
	min-height: 100vh;
	overflow-x: hidden;
	position: relative;
	width: 100%;
}
</style>
